module.exports = __webpack_public_path__ + "img/MARRØN.2db23864.jpg";